/**
 * Helper to manage document title, dynamic unread badge, and background tab flashing.
 */
class DocumentTitleHelper {
  constructor() {
    this.baseTitle =
      typeof document !== 'undefined' && document.title
        ? document.title
        : 'Chatwoot';
    this.unreadCount = 0;
    this.flashTimer = null;
    this.isFlashing = false;
    this.flashState = false;
    this.alertMessage = '收到新消息！';

    if (typeof window !== 'undefined') {
      window.addEventListener('focus', () => this.stopFlashing());
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
          this.stopFlashing();
        }
      });
    }
  }

  setBaseTitle(title) {
    if (title) {
      this.baseTitle = title;
      if (!this.isFlashing) {
        this.renderTitle();
      }
    }
  }

  setUnreadCount(count) {
    this.unreadCount = Math.max(0, Number(count) || 0);
    if (!this.isFlashing) {
      this.renderTitle();
    }
  }

  renderTitle() {
    if (typeof document === 'undefined') return;
    if (this.unreadCount > 0) {
      document.title = `(${this.unreadCount}) ${this.baseTitle}`;
    } else {
      document.title = this.baseTitle;
    }
  }

  flashNewMessage(messageText = '收到新消息！') {
    if (
      typeof document !== 'undefined' &&
      !document.hidden &&
      document.hasFocus &&
      document.hasFocus()
    ) {
      this.renderTitle();
      return;
    }

    this.alertMessage = messageText;
    this.startFlashing();
  }

  startFlashing() {
    if (typeof document === 'undefined') return;
    if (this.flashTimer) {
      clearInterval(this.flashTimer);
    }
    this.isFlashing = true;
    this.flashState = false;

    this.flashTimer = setInterval(() => {
      this.flashState = !this.flashState;
      if (this.flashState) {
        let countPrefix = '';
        if (this.unreadCount > 0) {
          countPrefix = `(${this.unreadCount}) `;
        }
        document.title = `💬 ${countPrefix}${this.alertMessage}`;
      } else {
        this.renderTitle();
      }
    }, 1000);
  }

  stopFlashing() {
    if (this.flashTimer) {
      clearInterval(this.flashTimer);
      this.flashTimer = null;
    }
    this.isFlashing = false;
    this.renderTitle();
  }
}

export default new DocumentTitleHelper();
